import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class EnhancedDialogService extends MatDialog {
  openWithTitle<T, D = any>(componentOrTemplateRef: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>): MatDialogRef<T> {
    if (!config || !config.panelClass) {
      config = { panelClass: 'title-dialog' };
    } else {
      config.panelClass += ' title-dialog';
    }
    return this.open(componentOrTemplateRef, config);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/EnhancedDialogService.ts